import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InventoryOrderReceivingProductList } from 'src/app/shared/interface/inventory-order-receiving-product-list';
import { ModalComponent } from "../../../../../shared/components/modal/modal-component";
import { EditWrapperComponent } from '../../../../../shared/components/edit-wrapper/edit-wrapper.component';
import { TarkTimePipe } from '@tarktech/tark-ng-utils';
@Component({
    selector: 'pos-inventory-duplicate-entry',
    templateUrl: './inventory-duplicate-entry.component.html',
    styleUrls: ['./inventory-duplicate-entry.component.scss'],
    imports: [EditWrapperComponent, TarkTimePipe]
})
export class InventoryDuplicateEntryComponent extends ModalComponent implements OnInit {


  @Input() productReceived: InventoryOrderReceivingProductList;
  @Input() productList: Array<InventoryOrderReceivingProductList> = [];
  @Input() date: string;
  close: EventEmitter<any> = new EventEmitter();

  constructor(duplicatePromptModalRef: BsModalRef) {
    super(duplicatePromptModalRef)
   }

  ngOnInit(): void {
  }

  onConfirm = () => {
    this.hide({});
  }

  onCancel = () => {
    this.hide({});
  }

}
